import React, { useEffect } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import {
  AlertInfo,
  BtnGroupStyle,
  ContentStyle,
  DataGridListStyle,
  DatePickerField,
  DRxInputStyle,
  DRxSelectStyle,
  greyColor,
  InputSMBoxStyle,
  SelectedReportList,
  warnColor,
  IframeStyle,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import LockIcon from "@mui/icons-material/Lock";
import { Form, Formik } from "formik";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import DRxInput from "../../../uikit/DRxInput";
import { TextNTooltip } from "../../../components/Content";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import useDebounce from "../../../CustomHooks/useDebounce";
import { useState } from "react";
import {
  GeneratePatientPharmaciesReport,
  Initializer,
  PatientSearchDetails,
} from "../../../Apis/AuthApiServices";
import NoRecords from "../../../components/NoRecords";
import ErrorOverlay from "../../../components/ErrorOverlay";
import { v4 as uuid } from "uuid";
import useFetch from "../../../CustomHooks/useFetch";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { useSelector } from "react-redux";
import { REPORT_BASE_URL } from "../../../Apis/Constants";
import { useOnBehalfContext } from "../../../context/OnbehalfContext";

const initialStatePatientPharmaciesReport = {
  VendorName: "DIGITAL RX",
  PracticeName: "Digital Rx Test",
  SearchBy: "",
  DateOfBirth: "",
  UserRole: "Physician",
  RadioData: "",
  ReportType: "PDF",
};

export default function PatientPharmaciesReport() {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const { onBehalfContext }: any = useOnBehalfContext();

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      cellClassName: "w30",
      headerClassName: "w30",
    },

    {
      field: "address",
      headerName: "Address",
      width: 350,
      cellClassName: "w40",
      headerClassName: "w40",
      renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    },
    {
      field: "homeTelephone",
      headerName: "Telephone No.",
      width: 180,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: ({ row }) => {
        return (
          <>
            <YSButton
              size="medium"
              children={"Add"}
              color="primary"
              variant="contained"
              className=""
              onClick={() => {
                setRowData([...rowData, row]);
              }}
            />
          </>
        );
      },
    },
  ];
  const [data, setData] = useState<any>({
    initialStatePatientPharmaciesReport,
  });
  const [rowData, setRowData] = useState<any>([]);
  const [value, setValue] = React.useState("");
  const [firstName, setFirstName] = useState("");
  const [dob, setDOB] = useState<any>("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState();
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [valueM, setValueM] = React.useState("");
  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );
  const lastNameDebounce = useDebounce(lastName, 1000);
  const firstNameDebounce = useDebounce(firstName, 1000);
  const dobDebounce = useDebounce(dob, 1000);

  const handleChangeR = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  const getGeneratePatientPharmaciesReport = async () => {
    try {
      const patientListIds: any = rowData?.map(
        (eachItem: any) => eachItem?.personId
      );

      const params = new URLSearchParams();
      params.append("patientList", patientListIds);

      const result = await GeneratePatientPharmaciesReport(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setReportUrl(result?.data?.response[0]?.reportName);
        setPrintActive(true);
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went Wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const getPatientSearch = async () => {
    try {
      setLoading(true);
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("pageNumber", `${page}`);
      const bodyData = {
        lastName: lastNameDebounce,
        firstName: firstNameDebounce,
        dateOfBirth: dobDebounce,
      };
      const result = await PatientSearchDetails(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setLoading(false);
        setError(false);
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "success",
            open: true,
          };
        });
        setData([]);
        setLoading(false);
        setError(false);
      }
    } catch (err) {
      setData([]);
      setLoading(false);
      setError(true);
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  useEffect(() => {
    if (lastNameDebounce || dobDebounce || firstNameDebounce) {
      getPatientSearch();
    }
  }, [page, lastNameDebounce, dobDebounce, firstNameDebounce]);

  useEffect(() => {
    setValueM(rowData.length >= 1 ? "true" : "false");
  }, [rowData.length, valueM]);

  const { data: initialData, loading: loadingData }: any = useFetch(
    {},
    Initializer,
    []
  );

  return (
    <>
      <ContentStyle>
        {printActive ? (
          <Grid
            container
            item
            xs={12}
            spacing={0}
            alignItems="top"
            justifyContent="space-between"
            columnSpacing={3}
          >
            <Grid item xs={12}>
              <IframeStyle>
                <iframe src={REPORT_BASE_URL + reportUrl} title="PrintReport" />
              </IframeStyle>
            </Grid>
            <Grid item xs={12}>
              <BtnGroupStyle className="right">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setPrintActive(false);
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography component="h6" color="primary" variant="h6">
              Patient Pharmacies Report
            </Typography>
            {loadingData ? (
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                height={"100vh"}
              >
                <CircularProgress color="primary" />
              </Grid>
            ) : (
              <>
                <Formik
                  initialValues={data}
                  onSubmit={(values) => {
                    console.log(values);
                  }}
                >
                  {({
                    handleChange,
                    values,
                    handleBlur,
                    touched,
                    errors,
                    setFieldValue,
                  }) => (
                    <Form>
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={0}
                        alignItems="top"
                        justifyContent="space-between"
                        columnSpacing={3}
                      >
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="vendorname"
                            >
                              Vendor Name
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>{" "}
                            <Box>
                              <DRxInputStyle>
                                <DRxInput
                                  id="vendorname"
                                  name="VendorName"
                                  type="text"
                                  className=""
                                  value={initialData[0]?.vendorName}
                                  disabled={true}
                                  onChange={handleChange}
                                />
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="practicename"
                            >
                              Practice Name
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>{" "}
                            <Box>
                              <DRxInputStyle>
                                <DRxInput
                                  id="practicename"
                                  name="Practice Name"
                                  type="text"
                                  className=""
                                  disabled={true}
                                  value={initialData[0]?.practiceName}
                                  onChange={handleChange}
                                />
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Stack
                          sx={{ width: "100%" }}
                          spacing={2}
                          marginBottom={3}
                          marginLeft={3}
                        >
                          <AlertInfo className="gray ni">
                            <Typography variant="body2" component={"div"}>
                              Select criteria to create a Patient Prescription
                              History and click on the{" "}
                              <Typography
                                fontWeight={600}
                                color={"primary"}
                                component={"span"}
                              >
                                "Generate Report"
                              </Typography>{" "}
                              button.
                            </Typography>{" "}
                          </AlertInfo>
                        </Stack>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="searchby"
                            >
                              Search by
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body1"
                              >
                                *
                              </Typography>
                            </Typography>
                            <Box>
                              <DRxInputStyle className="reportSearch">
                                <DRxInput
                                  id="searchby"
                                  className=""
                                  name="SearchBy"
                                  type={"search"}
                                  value={lastName}
                                  onChange={(e: any) => {
                                    setLastName(e.target.value);
                                  }}
                                  placeholder="Patient Last name"
                                />
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="dateofB"
                            >
                              Date of Birth
                            </Typography>

                            <Box>
                              <DatePickerField>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DatePicker
                                    inputFormat="MM/dd/yyyy"
                                    value={dob}
                                    onChange={(e) => {
                                      if (e === null) {
                                        setDOB("");
                                      } else {
                                        setDOB(moment(e).format("MM/DD/yyyy"));
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <>
                                        <TextField
                                          {...params}
                                          error={
                                            touched.DateOfBirth &&
                                            Boolean(errors.DateOfBirth)
                                          }
                                        />
                                      </>
                                    )}
                                  />
                                </LocalizationProvider>
                              </DatePickerField>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="userrole"
                            >
                              User Role
                            </Typography>
                            <Box>
                              <DRxSelectStyle>
                                <DRxInput
                                  name="UserRole"
                                  id="userrole"
                                  type="text"
                                  value={initialData[0]?.userRole}
                                  disabled={true}
                                />
                              </DRxSelectStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="searchby"
                            >
                              First Name
                            </Typography>
                            <Box>
                              <DRxInputStyle className="reportSearch">
                                <TextField
                                  id="searchby"
                                  className=""
                                  name="SearchBy"
                                  type={"search"}
                                  value={firstName}
                                  onChange={(e: any) => {
                                    setFirstName(e.target.value);
                                  }}
                                  placeholder="First name"
                                />
                              </DRxInputStyle>
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="userrole"
                            ></Typography>
                            <Box>
                              <SelectedReportList>
                                {" "}
                                <RadioGroup
                                  aria-labelledby="demo-controlled-radio-buttons-group"
                                  name="controlled-radio-buttons-group"
                                  value={value}
                                  onChange={handleChangeR}
                                >
                                  {rowData?.map((eachRow: any) => (
                                    <FormControlLabel
                                      value={eachRow?.name}
                                      control={<Radio color="primary" />}
                                      label={eachRow?.name}
                                    />
                                  ))}
                                </RadioGroup>
                              </SelectedReportList>
                              <YSButton
                                style={{ float: "right", marginTop: 10 }}
                                className=""
                                color="primary"
                                variant="contained"
                                children="Remove"
                                onClick={() => {
                                  let newData = rowData?.filter(
                                    (data: any) => data.name !== value
                                  );
                                  setRowData(newData);
                                }}
                                size="medium"
                              />
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <InputSMBoxStyle>
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="reporttype"
                            >
                              Report Type
                            </Typography>
                            <Box>
                              <DRxSelectStyle>
                                <DRxSelect2
                                  name="ReportType"
                                  id="reporttype"
                                  options={[{ value: "PDF", label: "PDF" }]}
                                  onChange={handleChange}
                                  value={
                                    initialStatePatientPharmaciesReport.ReportType
                                  }
                                />
                              </DRxSelectStyle>
                              <YSButton
                                style={{ marginTop: 35 }}
                                size="large"
                                className=""
                                color="primary"
                                dataTestId="submitBtn"
                                variant="contained"
                                disabled={
                                  // localStorage.getItem("onBehalf")
                                  onBehalfContext?.id &&
                                  UserServiceState?.profileGroup !== 11
                                    ? false
                                    : UserServiceState?.profileGroup > 9
                                    ? true
                                    : false
                                }
                                startIcon={
                                  // localStorage.getItem("onBehalf")
                                  onBehalfContext?.id &&
                                  UserServiceState?.profileGroup !== 11
                                    ? null
                                    : UserServiceState?.profileGroup > 9 && (
                                        <LockIcon />
                                      )
                                }
                                type="submit"
                                children={"Generate Reports"}
                                onClick={() => {
                                  getGeneratePatientPharmaciesReport();
                                }}
                              />
                            </Box>
                          </InputSMBoxStyle>
                        </Grid>
                        <Grid item xs={12} md={6}></Grid>
                        <Grid item xs={12} md={6} textAlign={"center"}></Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
                <Grid
                  container
                  item
                  xs={12}
                  spacing={1}
                  alignItems="top"
                  justifyContent="center"
                  marginTop={3}
                >
                  <Grid item xs={12}>
                    <DataGridListStyle className="report">
                      <DataGrid
                        rows={data[0]?.items ?? []}
                        headerHeight={36}
                        sortingOrder={["desc", "asc"]}
                        columns={columns}
                        autoHeight
                        rowHeight={40}
                        pageSize={pageSize}
                        rowsPerPageOptions={[10]}
                        disableSelectionOnClick
                        paginationMode="server"
                        components={{
                          NoRowsOverlay: NoRecords,
                          NoResultsOverlay: NoRecords,
                          ErrorOverlay: ErrorOverlay,
                        }}
                        error={error || undefined}
                        getRowId={(row) => row.personId ?? uuid()}
                        pagination
                        loading={loading}
                        onPageSizeChange={(newPageSize) =>
                          setPageSize(newPageSize)
                        }
                        page={page}
                        onPageChange={(newPage) => {
                          setPage(newPage);
                        }}
                        rowCount={rowCountState}
                      />
                    </DataGridListStyle>
                  </Grid>
                  <Grid item xs={12} textAlign="center" className="btns"></Grid>
                </Grid>{" "}
              </>
            )}
          </>
        )}
      </ContentStyle>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
